import {useEffect, useRef, useState} from 'react'
import {StyleSheet, View} from 'react-native'
import {type AppBskyEmbedVideo, type AppBskyFeedDefs} from '@atproto/api'
import type * as HlsTypes from 'hls.js'

export function VideoFeed() {
  return null
}

export function VideoItem({
  embed,
  videoRef: externalVideoRef,
  shouldPlay = false,
}: {
  player?: unknown
  post: AppBskyFeedDefs.PostView
  embed: AppBskyEmbedVideo.View
  active: boolean
  adjacent: boolean
  scrollGesture?: unknown
  moderation?: unknown
  feedContext?: string
  reqId?: string
  hideControls?: boolean
  onPlayEnd?: () => void
  videoRef?: React.RefObject<HTMLVideoElement | null>
  shouldPlay?: boolean
}) {
  const internalRef = useRef<HTMLVideoElement>(null)
  const videoRef = externalVideoRef ?? internalRef
  const [Hls, setHls] = useState<typeof HlsTypes.default | null>(null)

  useEffect(() => {
    import('hls.js').then(m => setHls(() => m.default))
  }, [])

  useEffect(() => {
    const video = videoRef.current
    if (!video || !embed?.playlist || !Hls) return

    let playRequest: Promise<void> | undefined

    if (Hls.isSupported()) {
      const hls = new Hls({autoStartLoad: true, startLevel: -1})
      hls.loadSource(embed.playlist)
      hls.attachMedia(video)
      if (shouldPlay) {
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.currentTime = 0
          playRequest = video.play()
          playRequest?.catch(() => {})
        })
      }
      return () => {
        const destroy = () => {
          video.pause()
          hls.destroy()
        }
        if (playRequest) {
          playRequest.then(destroy, destroy)
        } else {
          destroy()
        }
      }
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      // Safari native HLS
      video.src = embed.playlist
      if (shouldPlay) {
        playRequest = video.play()
        playRequest?.catch(() => {})
      }
    }
  }, [embed?.playlist, Hls, videoRef, shouldPlay])

  return (
    <View style={[StyleSheet.absoluteFill, {backgroundColor: 'black'}]}>
      {/* @ts-ignore - web only */}
      <video
        ref={videoRef}
        playsInline
        style={{width: '100%', height: '100%', objectFit: 'cover'}}
      />
    </View>
  )
}
